const { readsViaAgave } = require('../../tools/reads-via-agave')

// Should a location read — `get` or `getByIds` — be served over agave rather
// than from the local pouch?
//
// Three conditions, all necessary:
//
// - the resolver says agave, i.e. the user is online-only and keeps no local
//   integrated-data pouch for the raw read to find;
// - an agave transport exists. This is also what stops the recursion: agave's
//   own `location/get_raw_doc/by_ids` handler calls `getByIds`, and the fs-api
//   built inside agave has no agaveAdapter, so the read there stays local
//   instead of calling back out to the endpoint it is serving;
// - the caller passed no options. The endpoint takes a date — callers forward
//   theirs, and it selects the same service period server-side as it does here
//   — but nothing else, so honouring `{ raw: true }` means not going over HTTP.
//   The lambdas that pass it run server-side and are excluded by the adapter
//   condition anyway.
const shouldReadViaAgave = ({ agaveAdapter, state, options }) =>
  !!agaveAdapter &&
  options === undefined &&
  readsViaAgave(state, 'location')

module.exports = { shouldReadViaAgave }
